import { useCurrentUser } from "@/store/useUserStore";
import type { RoleName, UserModel } from "../../domain/models/User";

const PAYMENTS_ROLES: RoleName[] = ["Super administrator", "Administrator"];

const hasPaymentsRole = (user: UserModel | null): boolean =>
  (user?.roles ?? []).some((role) => PAYMENTS_ROLES.includes(role.name));

/**
 * Paiements reçus s'ouvre aux administrateurs par leur rôle, et à tout
 * utilisateur à qui l'onglet a été accordé depuis le paramétrage des accès.
 * Le rôle est la garantie : il vaut même si la permission n'a pas été cochée.
 */
export const canAccessPayments = (user: UserModel | null): boolean =>
  hasPaymentsRole(user) || (user?.tabs ?? []).includes("payments");

export const usePaymentsAccess = () => {
  const currentUser = useCurrentUser();

  return {
    isUserLoaded: currentUser !== null,
    canAccessPayments: canAccessPayments(currentUser),
  };
};
